// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-54c9a2a8] .van-icon-arrow-down:before{color:pink!important}", ""]);
// Exports
module.exports = exports;
